
import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TripDetail } from 'src/app/api/commonInterfaces';
import { DateTime } from 'luxon'
import { TripDropdownItem } from './tripDropdownItem';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TripDetailService } from 'src/app/api/trip-detail.service';
import { AutoCompleteSelectEvent } from 'primeng/autocomplete';

export interface TripDropdownConfiguration {
  showTripId: boolean,
  showGroupName: boolean,
  showLocation: boolean,
  showTripDate: boolean,
  
}



@Component({
    selector: 'app-trip-dropdown',
    templateUrl: './trip-dropdown.component.html',
    styleUrls: ['./trip-dropdown.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TripDropdownComponent),
            multi: true
        }
    ],
    standalone: false
})
export class TripDropdownComponent implements OnInit, ControlValueAccessor {

  constructor(
    private chRef: ChangeDetectorRef,
    private tripDetailService: TripDetailService
  ) { }



  onChange: any = () => { }
  onTouched: any = () => { }
  disabled = false
  touched = false

  requestedTripIdSelection: number = 0

  private _trips: TripDetail[] = [];
  @Input() set trips(value: TripDetail[]) {
    if (!value || !Array.isArray(value)) {
      this._trips = [];
    } else {
      this._trips = value.sort((a, b) => b.tripDate.valueOf() - a.tripDate.valueOf())
    }
    this.updateDropdownItems()
  }

  get trips(): TripDetail[] {
    return this._trips
  }

  allDropdownItems: TripDropdownItem[] = []

  private _dropdownItems: TripDropdownItem[] = [];
  get dropdownItems(): TripDropdownItem[] {
    return this._dropdownItems
  }


  config = {
    showTripId: true,
    showGroupName: false,
    showLocation: true,
    showTripDate: true,
  }


  @Input() set showTripId(value: boolean) {
    this.config.showTripId = value
    this.updateDropdownItems()
  }
  @Input() set showGroupName(value: boolean) {
    this.config.showGroupName = value
    this.updateDropdownItems()
  }
  @Input() set showLocation(value: boolean) {
    this.config.showLocation = value
    this.updateDropdownItems()
  }
  @Input() set showTripDate(value: boolean) {
    this.config.showTripDate = value
    this.updateDropdownItems()
  }
  


  private _readonly = false;
  @Input() set readonly(value: boolean) {
    this._readonly = value
  }

  get readonly() {
    return this._readonly
  }

  private _allowEmpty = false;
  @Input() set allowEmpty(value: boolean) {
    this._allowEmpty = value
    this.updateDropdownItems()
  }

  get allowEmpty(): boolean {
    return this._allowEmpty
  }

  @Input() showTooltip = false;


  @Output() tripSelect = new EventEmitter<TripDetail>()

  selectedTrip: TripDropdownItem | undefined;
  lastQuery: string = ""

  ngOnInit(): void {
  }

  updateDropdownItems() {
    if (!this.trips || !Array.isArray(this.trips)) {
      this.allDropdownItems = [];
    } else {
      this.allDropdownItems = this.trips.map(t => new TripDropdownItem(t, this.config))
    }
   
    if (this._allowEmpty) {//add an empty item
      this.allDropdownItems.unshift(new TripDropdownItem(
        { ...this.tripDetailService.emptyTrip(), location: "No Specific Trip" },
        { showGroupName: false, showLocation: true, showTripDate: false, showTripId: false }
      ))
    }
    this._dropdownItems = [...this.allDropdownItems]

    if (this.lastQuery) {
      this.search(this.lastQuery)
    }

    if (this.requestedTripIdSelection && !this.selectedTrip) {
      this.selectTrip(this.requestedTripIdSelection)
    }
  }

  search(event: any) {

    let filterSource: TripDropdownItem[]

    if (!event.query || event.query.length < this.lastQuery.length) {
      filterSource = this.allDropdownItems
    }
    else {
      filterSource = this.dropdownItems
    }

    this._dropdownItems = filterSource.filter(t => {
      return (this.config.showGroupName ? t.groupName.toLowerCase().includes(event.query.toLowerCase()) : false) ||
        (this.config.showLocation ? t.location.toLowerCase().includes(event.query.toLowerCase()) : false) ||
        (this.config.showTripDate ? DateTime.fromJSDate(t.tripDate).toFormat("MM/dd/yyyy").includes(event.query.toLowerCase()) : false) ||
        (this.config.showTripId ? t.id.toString().includes(event.query.toLowerCase()) : false)
    })

    this.lastQuery = event.query
  }

  onTripSelected($event: AutoCompleteSelectEvent) {
    let detail = undefined

    if (this.selectedTrip !== undefined) {
      detail = this.trips.find(t => t.id === parseInt(this.selectedTrip!.id, 10))
    }

    this.onChange(detail)
    this.tripSelect.emit(detail)
  }

  onTripClear() {
    this.selectedTrip = undefined
    this.onChange(null)
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


  writeValue(value: TripDetail): void {

    if (value) {
      this.selectedTrip = this.dropdownItems.find(t => t.id === value.id.toString())
    }
    else {
      this.selectedTrip = undefined
    }


  }

  selectTrip(tripId: number) {

    this.requestedTripIdSelection = tripId

    const trip = this.dropdownItems.find(t => t.id === tripId.toString())

    if (trip) {
      this.selectedTrip = trip
      this.tripSelect.emit(trip.detail)
      this.chRef.detectChanges()
    }
  }

  
  onInputBlur() {
    this.markAsTouched()
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true
    }
  }


}
